import { useMutation } from '@cedarjs/web';
import { toast } from "@cedarjs/web/toast";
import ReviewForm from '../ReviewForm/ReviewForm';
import ReviewCommentForm from "../ReviewCommentForm/ReviewCommentForm";
import ReviewComment from "../ReviewComment/ReviewComment";
import { Paper } from "@mui/material";



export const CREATE_REVIEW = gql`
  mutation CreateReviewMutation($input: CreateReviewInput!) {
    createReview(input: $input) {
      id
    }
  }
`
export const UPDATE_REVIEW = gql`
  mutation UpdateReviewMutation($id: Int!, $input: UpdateReviewInput!) {
    updateReview(id:$id, input: $input) {
      id
    }
  }
`

const NewReview = (props) => {

  const [createReview] = useMutation(CREATE_REVIEW,{ onError(error, clientOptions) { toast.error(error.message) }})
  const [updateReview] = useMutation(UPDATE_REVIEW,{ onError(error, clientOptions) { toast.error(error.message) }})

  const onSave = async (reviewInput, id = null) => {
    let review;

    if(!id)
     review = await createReview({ variables: { input:reviewInput }, refetchQueries: ['FindReviewsQuery','FindReviewsSiteQuery', 'FindNewReviewQuery', 'TankInfosQuery', 'BatchInfosQuery']})
    else 
      review = await updateReview({ variables: { input:reviewInput, id }, refetchQueries: ['FindReviewsQuery','FindReviewsSiteQuery', 'FindNewReviewQuery', 'TankInfosQuery', 'BatchInfosQuery']})

    return review;
  }

  return (
    <div>
      <ReviewForm 
        review={props.review}
        tank={props.tank}
        onSave={onSave} 
        className={props.className}/>
      {/* {props.review && 
        <Paper className="p-4 mb-2">
          <ReviewComment parent={props.review} isInline={true}/>
        </Paper>
        } */}
    </div>
  )
}

export default NewReview
